export function cnpjValidation(value) {
  if (!value) return false

  const input = Array.isArray(value) ? value.join('') : String(value)
  const normalizedInput = input.trim().toUpperCase()

  const plainPattern = /^[A-Z0-9]{12}\d{2}$/
  const formattedPattern =
    /^[A-Z0-9]{2}\.[A-Z0-9]{3}\.[A-Z0-9]{3}\/[A-Z0-9]{4}-\d{2}$/

  if (
    !plainPattern.test(normalizedInput) &&
    !formattedPattern.test(normalizedInput)
  ) {
    return false
  }

  const cnpj = normalizedInput.replace(/[^A-Z0-9]/g, '')

  if (cnpj.length !== 14) return false

  // Preserva o comportamento legado para casos triviais inválidos puramente numéricos.
  if (/^\d{14}$/.test(cnpj) && /^(\d)\1{13}$/.test(cnpj)) return false

  const mapCharToValue = (char) => {
    if (/\d/.test(char)) return Number(char)

    return char.charCodeAt(0) - 48
  }

  const values = cnpj.slice(0, 12).split('').map(mapCharToValue)
  const verifierDigits = cnpj.slice(12).split('').map(Number)

  const calculateDigit = (numbers, weights) => {
    const sum = numbers.reduce((acc, n, index) => acc + n * weights[index], 0)
    const remainder = sum % 11

    return remainder < 2 ? 0 : 11 - remainder
  }

  const firstWeights = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  const secondWeights = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

  const digit0 = calculateDigit(values, firstWeights)

  if (digit0 !== verifierDigits[0]) return false

  const digit1 = calculateDigit([...values, digit0], secondWeights)

  return digit1 === verifierDigits[1]
}
